export default "__VITE_ASSET__COjzP2_$__"